import { Link } from 'react-router-dom';
import { VanguardNav } from '../components/vanguard/VanguardNav';
import { LandingFooter } from '../components/landing/LandingFooter';
import { PageTransition } from '../components/common/PageTransition';
import { usePageMeta } from '../lib/usePageMeta';
import { useJsonLd } from '../lib/useJsonLd';
import { listarArtigos } from '../data/artigos';

const SITE = 'https://paccesadvogados.com.br';

export const ConteudoPage = () => {
    const artigos = listarArtigos();
    const [destaque, ...demais] = artigos;

    usePageMeta({
        title: 'Conteúdo sobre Direito Imobiliário | Pacces Advogados',
        description:
            'Artigos sobre usucapião e regularização de imóveis: contrato de gaveta, documentos necessários, etapas do procedimento e as duas vias do pedido.',
        // TEMPORARIO — retirar quando o Dr. Luke validar os textos.
        // O blog sobe junto no bundle (o build e unico), mas nao deve ser
        // indexado antes da aprovacao. Ao liberar: apagar esta linha E
        // devolver as URLs ao public/sitemap.xml.
        robots: 'noindex, follow',
        canonical: `${SITE}/conteudo`,
        image: `${SITE}/blog/cartorio.jpg`,
    });

    useJsonLd(
        [
            {
                '@context': 'https://schema.org',
                '@type': 'CollectionPage',
                name: 'Conteúdo sobre Direito Imobiliário',
                url: `${SITE}/conteudo`,
                publisher: { '@type': 'Organization', name: 'Pacces Advogados', url: SITE },
                hasPart: artigos.map((a) => ({
                    '@type': 'Article',
                    headline: a.titulo,
                    url: `${SITE}/conteudo/${a.slug}`,
                })),
            },
        ],
        'conteudo-indice',
    );

    return (
        <PageTransition>
            <div className="bg-white dark:bg-vanguard-background-dark text-stone-900 dark:text-stone-300 font-vanguard-sans transition-colors duration-300 [&_p]:text-left">
                <VanguardNav />

                <header className="max-w-6xl mx-auto px-6 lg:px-8 pt-32 pb-16 md:pt-40">
                    {/* O ouro #C5A27D reprova como texto em fundo claro (2,38:1).
                        Em fundo claro o papel de texto é do vanguard-accent. */}
                    <p className="text-[11px] md:text-xs tracking-[0.35em] uppercase text-vanguard-accent dark:text-vanguard-primary font-medium">
                        Conteúdo
                    </p>
                    <h1 className="mt-5 font-serif text-4xl md:text-6xl leading-[1.05] text-pacces-ebony dark:text-white max-w-3xl">
                        Direito imobiliário, explicado sem juridiquês.
                    </h1>
                    <p className="mt-6 font-vanguard-blog text-lg md:text-xl leading-relaxed text-stone-600 dark:text-stone-400 max-w-2xl">
                        As dúvidas que mais chegam ao escritório sobre usucapião e regularização de imóveis, respondidas uma a uma.
                    </p>
                    <div className="mt-10 h-px w-24 bg-vanguard-primary" />
                </header>

                <main className="max-w-6xl mx-auto px-6 lg:px-8 pb-28">
                    {/* Destaque */}
                    {destaque && (
                        <Link
                            to={`/conteudo/${destaque.slug}`}
                            className="group block mb-20 md:mb-24"
                        >
                            <div className="grid md:grid-cols-2 gap-8 md:gap-14 items-center">
                                <div className="overflow-hidden rounded-md">
                                    <img
                                        src={destaque.imagem}
                                        alt={destaque.imagemAlt}
                                        className="w-full h-64 md:h-[26rem] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                                        loading="eager"
                                    />
                                </div>
                                <div>
                                    <p className="text-[11px] tracking-[0.28em] uppercase text-vanguard-accent dark:text-vanguard-primary font-medium">
                                        {destaque.categoria} · {destaque.leituraMin} min de leitura
                                    </p>
                                    <h2 className="mt-4 font-serif text-3xl md:text-4xl leading-tight text-pacces-ebony dark:text-white group-hover:text-vanguard-accent dark:group-hover:text-vanguard-primary transition-colors">
                                        {destaque.titulo}
                                    </h2>
                                    <p className="mt-5 font-vanguard-blog text-base md:text-lg leading-relaxed text-stone-600 dark:text-stone-400">
                                        {destaque.resumo}
                                    </p>
                                    <span className="mt-7 inline-flex items-center gap-3 text-xs tracking-[0.22em] uppercase font-semibold text-vanguard-accent dark:text-vanguard-primary">
                                        Ler o guia
                                        <span aria-hidden className="transition-transform group-hover:translate-x-1">→</span>
                                    </span>
                                </div>
                            </div>
                        </Link>
                    )}

                    <div className="h-px w-full bg-stone-200 dark:bg-stone-800 mb-16" />

                    {/* Demais artigos */}
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
                        {demais.map((a) => (
                            <Link key={a.slug} to={`/conteudo/${a.slug}`} className="group block">
                                <div className="overflow-hidden rounded-md">
                                    <img
                                        src={a.imagem}
                                        alt={a.imagemAlt}
                                        className="w-full h-52 object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                                        loading="lazy"
                                    />
                                </div>
                                <p className="mt-5 text-[11px] tracking-[0.28em] uppercase text-vanguard-accent dark:text-vanguard-primary font-medium">
                                    {a.categoria} · {a.leituraMin} min
                                </p>
                                <h3 className="mt-3 font-serif text-xl md:text-2xl leading-snug text-pacces-ebony dark:text-white group-hover:text-vanguard-accent dark:group-hover:text-vanguard-primary transition-colors">
                                    {a.titulo}
                                </h3>
                                <p className="mt-3 font-vanguard-blog text-[15px] leading-relaxed text-stone-600 dark:text-stone-400">
                                    {a.resumo}
                                </p>
                            </Link>
                        ))}
                    </div>
                </main>

                <LandingFooter />
            </div>
        </PageTransition>
    );
};
